﻿import { analyticsEvent } from '../controllers/analytics-controller';
(function ($) {
  const loadRelatedArticles = () => {
    const articleNumber = $("#fur-read-articleNumber").val();
    const pageTitle = $("#fur-read-pageTitle").val();
    const pageType = $("#fur-read-pageType").val();

    if (!articleNumber) return;

    $.ajax({
      type: "GET",
      url: `/api/informasearch/fetchrelatedarticle?articleNumber=${articleNumber}`,
      success: function (result) {
        const $iirisRelatedArticles = $(".iirisrelatedarticles");
        $iirisRelatedArticles.each(function () {
          const $iirisRelatedArticle = $(this);

          // Sidebar detection
          if ($iirisRelatedArticle.closest('.pop-out').length > 0) {
            $iirisRelatedArticle.addClass('in-sidebar');
          }

          if (Array.isArray(result) && result.length > 0) {
            $iirisRelatedArticle.html('');
            const $maxItem = $("#fur-read-max-item");
            if ($maxItem.length === 0) return;

            const furReadMaxItem = parseInt($maxItem.val(), 10);
            let html = '';

            if (!$iirisRelatedArticle.hasClass('in-sidebar')) {
              $iirisRelatedArticle.removeClass('inf-row');
              html += '<div class="owl-carousel">';
            }

            const itemCount = Math.min(result.length, furReadMaxItem) - 1;
            for (let i = 0; i <= itemCount; i++) {
              const article = result[i];
              const articleURL = article.url;
              const data = {
                event_name: 'related_content_click_through',
                'iiris-ref': 'recommend',
                click_through_source: pageTitle,
                click_through_destination: article.title,
                source_page_type: pageType
              };

              html += `
                <div class="inf-col-fluid">
                  <div class="content-box bdr-top featured-research-container">
                    <div class="asset_family_mod">
                      <h5 class='omd-marg-b-1'>
                        <a href="${articleURL}" class="click-utag" data-info='${JSON.stringify(data)}'>${article.title}</a>
                      </h5>
                      <p class="body">${article.synopsis}</p>
                      <p class="omd-label omg-marg-b-1">${article.listableAuthorByLine}</p>
                      <div class="entitlement">
                        <div class="article_restricted_access">
                          ${article.ShowLock
                            ? `<svg class="lock__icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/img/svg-sprite.svg#lock"></use></svg>`
                            : `<svg class="lock-open__icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/img/svg-sprite.svg#lock-open"></use></svg>`
                          }
                          ${article.entitledText}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              `;
            }

            if (!$iirisRelatedArticle.hasClass('in-sidebar')) {
              html += '</div>';
            }

            $iirisRelatedArticle.html(html);

            // Analytics click handler
            $('.iirisrelatedarticles .asset_family_mod').each(function () {
              const $anchor = $(this).find(".click-utag");
              $(this).off('click').on('click', function () {
                let dataInfo = $anchor.data('info');
                if ($anchor.hasClass("legacy_data_info_ignore")) {
                  dataInfo = null;
                }
                if (!dataInfo) {
                  dataInfo = $anchor.data();
                }
                analyticsEvent($.extend(analytics_data, dataInfo));
                window.location.href = $anchor.attr("href");
              });
            });

            $(".omdia-recommends-box-popout-button").show();
            furtherReadingCarouselInit();
          } else {
            $("#iiris-related-articles").hide();
            $(".omdia-recommends-box-popout-button").hide();
            //$('.omd-further-reading').parent().hide();
          }
        });
      },
      error: function () {
        console.log('error calling function');
        $("#iiris-related-articles").hide();
      }
    });
  };

  const furtherReadingCarouselInit = () => {
    const $owlCarousels = $(".omd-further-reading .owl-carousel");
    const owlItemCount = $owlCarousels.children().length;
    const desktopItemCount = 3;
    const tabletItemCount = 2;
    const mobileItemCount = 1;
    const desktopWidth = 1280;
    const tabletWidth = 768;
    const windowWidth = $(window).width();
    const isDesktop = windowWidth >= desktopWidth;
    const isTablet = !isDesktop && windowWidth >= tabletWidth;
    const isMobile = !isTablet && !isDesktop;

    $owlCarousels.each(function () {
      const $owlCarousel = $(this);

      $owlCarousel.on("onInitAfter", function () {
        if (isDesktop) {
          $owlCarousel.find(".owl-next").addClass("disabled");
        } else {
          $owlCarousel.find(".owl-prev").addClass("disabled");
        }
      });

      $owlCarousel.on("onChangeState", function () {
        const owlCarouselData = $(this).data("owlCarousel");
        if (!owlCarouselData) return;

        const { current, min, max } = owlCarouselData.pos;
        const { $navNext, $navPrev } = owlCarouselData.dom;

        switch (current) {
          case min:
            if (isDesktop) {
              $navNext.addClass("disabled");
              $navPrev.removeClass("disabled");
            } else {
              $navNext.removeClass("disabled");
              $navPrev.addClass("disabled");
            }
            break;
          case max:
            if (isDesktop) {
              $navNext.removeClass("disabled");
              $navPrev.addClass("disabled");
            } else {
              $navNext.addClass("disabled");
              $navPrev.removeClass("disabled");
            }
            break;
        }
      });

      $owlCarousel.owlCarousel({
        responsiveClass: true,
        loop: false,
        items: desktopItemCount,
        slideBy: desktopItemCount,
        nav: true,
        dots: true,
        callbacks: true,
        navText: [
          "<svg><use xlink:href='/dist/img/svg-sprite.svg#sorting-arrow-table'></use></svg>",
          "<svg><use xlink:href='/dist/img/svg-sprite.svg#sorting-arrow-table'></use></svg>",
        ],
        responsive: {
          0: {
            items: mobileItemCount,
            slideBy: 1,
          },
          [tabletWidth]: {
            items: tabletItemCount,
            slideBy: 1,
          },
          [desktopWidth]: {
            items: desktopItemCount,
            slideBy: desktopItemCount,
          },
        },
      });
    });
  };

  window.addEventListener("DOMContentLoaded", () => {
    loadRelatedArticles();
    const isArticle = $(".omd-further-reading .further-reading-cols.in-sidebar .inf-col-fluid");
    if (isArticle && isArticle.length !== 0) {
      $(".omdia-recommends-box-popout-button").show();
    }
    furtherReadingCarouselInit();
  });
})(Zepto);